import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue'),
  },
  {
    path: '/rotacion',
    name: 'Rotacion',
    component: () => import('../views/RotacionView.vue'),
  },
  {
    path: '/jurados/:codigo_rotacion',
    name: 'Jurados',
    component: () => import('../views/JuradosView.vue'),
  },
  {
    path: '/notas/ritmica',
    name: 'Notas_Ritmica',
    component: () => import('../views/Ritmica/NotasView.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
